/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessUnitOverviewDto
 */
export interface BusinessUnitOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitOverviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitOverviewDto
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitOverviewDto
     */
    totalOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitOverviewDto
     */
    totalOrderAmount: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitOverviewDto
     */
    description: string | null;
    /**
     * 
     * @type {Array<BusinessUnitOverviewDto>}
     * @memberof BusinessUnitOverviewDto
     */
    children?: Array<BusinessUnitOverviewDto> | null;
}

/**
 * Check if a given object implements the BusinessUnitOverviewDto interface.
 */
export function instanceOfBusinessUnitOverviewDto(value: object): value is BusinessUnitOverviewDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalOrderCount' in value) || value['totalOrderCount'] === undefined) return false;
    if (!('totalOrderAmount' in value) || value['totalOrderAmount'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function BusinessUnitOverviewDtoFromJSON(json: any): BusinessUnitOverviewDto {
    return BusinessUnitOverviewDtoFromJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'totalOrderCount': json['totalOrderCount'],
        'totalOrderAmount': json['totalOrderAmount'],
        'description': json['description'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(BusinessUnitOverviewDtoFromJSON)),
    };
}

export function BusinessUnitOverviewDtoToJSON(json: any): BusinessUnitOverviewDto {
    return BusinessUnitOverviewDtoToJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoToJSONTyped(value?: BusinessUnitOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'totalOrderCount': value['totalOrderCount'],
        'totalOrderAmount': value['totalOrderAmount'],
        'description': value['description'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(BusinessUnitOverviewDtoToJSON)),
    };
}

